import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@core/auth/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { ComplianceComponent } from './compliance.component';
const routes: Routes = [   
  {
    path: '',
    component: ComplianceComponent ,
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComplianceRoutingModule { }
